import React from 'react';
import { Modal, Button, ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IoIosPerson } from 'react-icons/io';

function PartnerChangeModal({ currentPartner, userPartners, show, onHide, onPartnerChange }) {
    const { t } = useTranslation();

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {t('settings.change_organization')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ListGroup defaultActiveKey={currentPartner.partnerID}>
                    {userPartners.map(p => (
                        <ListGroup.Item
                            className="partnerSelectItem"
                            key={p.partnerID}
                        >
                            <div>
                                <Button
                                    size="sm"
                                    style={{ float:'right' }}
                                    onClick={() => onPartnerChange(p)}
                                    active={currentPartner.partnerID === p.partnerID}
                                    variant={currentPartner.partnerID === p.partnerID ? 'primary' : 'outline-primary'}
                                >
                                    {currentPartner.partnerID === p.partnerID ? t('general.active') : t('general.select')}
                                </Button>
                                <h4><IoIosPerson style={{ color: "#0093BF", marginTop: -6 }} /> {p.name}</h4>
                            </div>
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    type="button"
                    variant="default"
                    onClick={onHide}
                >
                    {t('general.close')}
                </Button>
            </Modal.Footer>
        </Modal>
    )
};

export default PartnerChangeModal;